import React, { useEffect } from 'react';
import { IoIosClose } from 'react-icons/io';
import { MdCheckCircle } from "react-icons/md";
import { BiSolidErrorCircle } from "react-icons/bi";
import { BiSolidError } from "react-icons/bi";
import { BiSolidErrorAlt } from "react-icons/bi";

export default function Alert({ show = false, message = '', type = 'success', setShowAlert }) {
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setShowAlert({ show: false, message: '', type: '' });
      }, 5000);
    }
  }, [show]);

  const getBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-[#378e3c]';
      case 'info':
        return 'bg-[#0388d1]';
      case 'warning':
        return 'bg-[#f57c01]';
      case 'error':
        return 'bg-[#d3302f]';
    }
  };

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <MdCheckCircle />;
      case 'info':
        return <BiSolidErrorCircle />;
      case 'warning':
        return <BiSolidError />;
      case 'error':
        return <BiSolidErrorAlt />;
    }
  };

  return (
    <div 
      className={`fixed w-full top-0 left-0 transition-transform duration-1000 ${show ? 'translate-y-0' : '-translate-y-full'}`}
      style={{ zIndex: 1000 }}
    >
      <div 
        className={`flex ${getBgColor()} text-white rounded-lg text-sm font-semibold justify-between items-center mx-auto p-3 mt-3`} 
        role="alert" style={{ width: '98%' }}
      >
        <div className="flex items-center">
          <div className="mr-2">{getIcon()}</div>

          <p>{message}</p>
        </div>

        <button className="text-white font-semibold" onClick={() => setShowAlert(false)}>
          <IoIosClose className="w-7 h-7" color='#fff' size={28} />
        </button>
      </div>
    </div>
  );
};
